import Column from '@app/components/layout/Column'
import { useTranslations } from '@i18n/useLanguage'
import { TabsGroup } from '@app/components/core/tabs/Tabs'
import { match } from 'ts-pattern'
import { Overview } from './tabContent/Overview'
import { RegularContentTab } from './tabContent/RegularContentTab'
import { Thread } from '../../../../components/blocks/thread/Thread'
import { useParamState } from '@app/util/hooks/useParamState'
import { ViewPlotModel } from 'functions/app/plot/view'

const tabs = {
  overview: 'overview',
  application: 'application',
  documents: 'documents',
  thread: 'thread',
} as const

export const TabContent = ({ plot }: { plot: ViewPlotModel }) => {
  const translations = useTranslations().app.plotPage
  const [tab, setTab] = useParamState(tabs, tabs.overview)
  const applicationTabSections =
    plot.contentBlocks?.filter(
      (c: { type: string; $position: string }) =>
        c.$position === 'applicationTab',
    ) ?? []
  const documentsTabSections =
    plot.contentBlocks?.filter(
      (c: { type: string; $position: string }) =>
        c.$position === 'documentsTab',
    ) ?? []
  return (
    <Column alignItems="stretch" gap="2rem">
      <TabsGroup
        selectedTab={tab}
        onSelectTab={setTab}
        tabs={[
          { label: translations.overview, value: tabs.overview },
          {
            label: translations.applicationProcedure,
            value: tabs.application,
            isVisible: plot.byCrowdbuilding,
          },
          {
            label: translations.documents,
            value: tabs.documents,
            isVisible: plot.byCrowdbuilding,
          },
          { label: translations.thread, value: tabs.thread },
        ]}
      />
      {match(tab)
        .with(tabs.overview, () => <Overview key="overview" plot={plot} />)
        .with(tabs.application, () => (
          <RegularContentTab
            key="application"
            sections={applicationTabSections}
          />
        ))
        .with(tabs.documents, () => (
          <RegularContentTab key="documents" sections={documentsTabSections} />
        ))
        .with(tabs.thread, () =>
          plot.thread?.id ? (
            <Thread key="thread" threadId={plot.thread.id} />
          ) : null,
        )
        .exhaustive()}
    </Column>
  )
}
